import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';
import {
  BodyText,
  Icon,
  LoadingPlaceholder,
  theme,
  useResponsive,
} from '@sg/garnish';

export const GiftCardBalance = (props: GiftCardBalanceProps) => {
  const { giftCardBalance, isLoading } = props;
  const { formatMessage, formatNumber } = useIntl();
  const { match } = useResponsive();

  return (
    <View style={match([styles.containerXS, styles.containerSM])}>
      <View style={styles.giftCardBalanceInfo}>
        <Icon name="IconCredit" width={24} height={24} />

        <BodyText sizeMatch={['14', '24']}>
          {formatMessage(messages.entry)}
        </BodyText>
      </View>

      {isLoading ? (
        <LoadingPlaceholder
          rows={1}
          rowHeight={24}
          columnWidth={match([40, 64])}
          palette="lightestKale"
        />
      ) : (
        <BodyText sizeMatch={['14', '24']}>
          {formatNumber(giftCardBalance / 100, {
            style: 'currency',
            currency: 'USD',
          })}
        </BodyText>
      )}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  containerXS: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: theme.spacing['2'],
    paddingBottom: theme.spacing['6'],
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.LIGHT,
  },
  containerSM: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: theme.radius.large,
    borderWidth: 1,
    borderColor: theme.colors.GRAY,
    paddingVertical: theme.spacing['12'],
    paddingHorizontal: theme.spacing['6'],
    gap: theme.spacing['4'],
  },
  giftCardBalanceInfo: {
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: theme.spacing['4'],
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  entry: {
    defaultMessage: 'Sweetgreen gift card',
    description: 'Gift Card Info | Entry',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type GiftCardBalanceProps = {
  giftCardBalance: number;
  isLoading: boolean;
};
